import { useContext } from 'react'
import { RegisterContext } from '../context/RegisterContext'

export const useRegisterContext = () => {
	const context = useContext(RegisterContext)
	return context
}
